module.exports = "/images/relate.jpg";